import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-affb5aac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tab-title" }, "Manage Reports", -1))
const _hoisted_3 = { class: "form" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "form-row w-1/2"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Download Report", -1))
const _hoisted_7 = { class: "download" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Select team", -1))
const _hoisted_9 = ["value"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Select date range", -1))
const _hoisted_11 = { class: "download-button" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, null, -1))
const _hoisted_13 = {
  key: 0,
  class: "error"
}
const _hoisted_14 = {
  key: 2,
  class: "form-row w-1/2"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Schedule report", -1))
const _hoisted_16 = { class: "email-container form-field" }
const _hoisted_17 = { class: "date-frequency-container" }
const _hoisted_18 = { class: "date" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Select date", -1))
const _hoisted_20 = { class: "freq" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Select frequency", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "ONCE" }, "Send Once", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "DAILY" }, "Daily (Day's Report)", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "WEEKLY" }, "Weekly (Week's Report)", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "MONTHLY" }, "Monthly (Month's Report)", -1))
const _hoisted_26 = [
  _hoisted_22,
  _hoisted_23,
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = { class: "schedule-button" }
const _hoisted_28 = {
  key: 0,
  class: "error"
}
const _hoisted_29 = {
  key: 1,
  class: "success"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_litepie_datepicker = _resolveComponent("litepie-datepicker")!
  const _component_LoadingButton = _resolveComponent("LoadingButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (!_ctx.downloadTeamId)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, "No teams to display"))
        : _createCommentVNode("", true),
      (_ctx.teamsRef.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _withDirectives(_createElementVNode("select", {
                class: "form-field team-selection",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.downloadTeamId) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamsRef, (team) => {
                  return (_openBlock(), _createElementBlock("option", {
                    class: "select-option",
                    value: team.id,
                    key: team.id
                  }, _toDisplayString(team.name), 9, _hoisted_9))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.downloadTeamId]
              ]),
              _createElementVNode("div", null, [
                _hoisted_10,
                _createVNode(_component_litepie_datepicker, {
                  class: "datepicker",
                  "disable-date": _ctx.futureDates,
                  placeholder: "Select date range",
                  disabled: _ctx.isDownloading,
                  formatter: { date: 'YYYY-MM-DD', month: 'MMM' },
                  modelValue: _ctx.downloadDateRange,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.downloadDateRange) = $event))
                }, null, 8, ["disable-date", "disabled", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_LoadingButton, {
                  onClick: _ctx.handleDownloadSelection,
                  loading: _ctx.isDownloading,
                  disabled: _ctx.isDownloading
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Download ")
                  ]),
                  _: 1
                }, 8, ["onClick", "loading", "disabled"]),
                (_ctx.errorMessage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.errorMessage), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.downloadTeamId)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.targetEmail) = $event)),
                type: "email",
                placeholder: "Enter email address",
                class: "form-field email-input"
              }, null, 512), [
                [_vModelText, _ctx.targetEmail]
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createVNode(_component_litepie_datepicker, {
                    "as-single": "",
                    placeholder: "Select date",
                    class: "datepicker",
                    "disable-date": _ctx.pastDates,
                    disabled: _ctx.isDownloading,
                    formatter: { date: 'YYYY-MM-DD', month: 'MMM' },
                    modelValue: _ctx.scheduleStartDate,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.scheduleStartDate) = $event))
                  }, null, 8, ["disable-date", "disabled", "modelValue"])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _withDirectives(_createElementVNode("select", {
                    class: "freq-selector",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.frequency) = $event))
                  }, _hoisted_26, 512), [
                    [_vModelSelect, _ctx.frequency]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_LoadingButton, {
                  onClick: _ctx.handleScheduleReport,
                  loading: _ctx.isScheduling,
                  disabled: _ctx.isScheduling
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.shouldSendNow ? 'Send now' : 'Schedule'), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "loading", "disabled"]),
                (_ctx.schedulingErrorMessage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.schedulingErrorMessage), 1))
                  : _createCommentVNode("", true),
                (_ctx.schedulingSuccessMessage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.schedulingSuccessMessage), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}